export enum ErrorCodes {
    REFEREE_EXISTS = "REFEREE_EXISTS",
    INTERNAL = "INTERNAL",
    GENERIC = "GENERIC",
}
